import { ModalQuestionIco } from '@modules/CustomIcons'
import { QueryStatus } from '@reduxjs/toolkit/query'
import { arrayBufferToBase64, AsanSigning, CompleteData } from '@shared/AsanSigning'
import { useAppSelector } from '@shared/hooks/useAppSelector'
import { useCustomModal } from '@shared/Modal'
import { t } from 'i18next'
import moment from 'moment'
import { DEACTIVE } from 'pages/BusinessCards/components/LimitsPage/constants/constantForLimits'
import CustomResult from 'pages/BusinessCards/components/LimitsPage/utils/CustomResult'
import React, { useState } from 'react'
import { useFormContext } from 'react-hook-form'
import { useDispatch } from 'react-redux'
import {
  limitsCardApi,
  useDisabledLimitForBusinnessCardMutation,
  useFetchByDocTypeMutation,
} from 'store/reducers/limitsforBusinnesCard/cardLimits.api'

function DisabledLimit() {
  const dispatch = useDispatch()

  const { closeModal, setStatus } = useCustomModal()
  const [asanOpen, setAsanOpen] = useState(false)
  const { getValues, trigger } = useFormContext()
  const [disabledLimitForBusinnessCard, { status, error, isSuccess }] =
    useDisabledLimitForBusinnessCardMutation()

  async function disabledLimit({transactionId}: CompleteData) {
    const isValid = await trigger()

    if (isValid) {
      const updateRequestData = getValues()
      const request = {
        ...updateRequestData,
        status: DEACTIVE,
        transactionId,
      }
      disabledLimitForBusinnessCard({ requestData: request })
        .unwrap()
        .then(() => {
          setStatus({
            status: QueryStatus.fulfilled,
            message: t('businessCards.operationSuccessNote'),
          })
        })
        .catch((err) =>
          setStatus({ status: QueryStatus.rejected, message: err?.data })
        )
    }
  }
  return (
    <>
      <AsanSigning
        asanKey="LMT"
        docType="LMT"
        checkSignCallback={() => true}
        afterCloseFn={() => {
          isSuccess && dispatch(limitsCardApi.util.resetApiState())
        }}
        checkDirectorFnWithProps={[
          useFetchByDocTypeMutation,
          {
            isClickCardBlockButton: false,
            docType: 'LMT',
          },
        ]}
        defaultOpen={[asanOpen, setAsanOpen]}
        onComplete={(data) => {
          disabledLimit(data)
        }}
        status={status}
        errorend={error}
        handleSigning={() => ({
          files: [
            {
              name: `biznes_kart_${moment().format('DD.MM.YYYY')}.json`,
              mimeType: 'application/json',
              encodedBytes: arrayBufferToBase64({ ...getValues(), status: DEACTIVE }),
            },
          ],
        })}
      />
      <CustomResult
        icon={<ModalQuestionIco />}
        text={t('businessCards.sureLimitedCard')}
        buttons={[
          {
            label: t('home.no'),
            type: 'default',
            onClick: closeModal,
          },
          {
            label: t('home.yes'),
            type: 'primary',
            onClick: () => {
              setAsanOpen(true)
              closeModal()
            },
          },
        ]}
      />
    </>
  )
}

export default DisabledLimit
